import { h, Component } from "preact";
import { Link } from "preact-router/match";
import queryString from "query-string";
import { connect } from "react-redux";
import {
  getUserEvents,
  getEvent,
  getAdditionalQuestionsPreview
} from "../../state/actions/eventActions";
import { generateDummyOrder } from "../../state/actions/orderActions";
import { parseQueryString } from "../../utils/Format";
import config from "../../config";
import Details from "../details/Details";
import OrderQuestions from "../details/OrderQuestions";

class AdditionalQuestionsPreview extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { eventSlug, event, getAdditionalQuestionsPreview } = this.props;
    if (!event.data && !event.loading) {
      getAdditionalQuestionsPreview(eventSlug);
    }
  }
  render() {
    const { event, generateDummyOrder, order } = this.props;
    if (!event || !event.data || event.loading) {
      return null;
    }
    if ((!order || !order.data) && !order.loading) {
      generateDummyOrder(event);
      return null;
    }
    return (
      <div>
        <Details additionalQuestionsPreview={true} />
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => {
    return {
      event: state.event,
      order: state.order
    };
  },
  {
    getUserEvents,
    getEvent,
    generateDummyOrder,
    getAdditionalQuestionsPreview
  }
)(AdditionalQuestionsPreview);



// WEBPACK FOOTER //
// ./routes/widgets/AdditionalQuestionsPreview.js